import { Suspense, ReactNode } from 'react';
import { LoadingScreen } from '@/components/common/LoadingScreen';

interface LazyWrapperProps {
  children: ReactNode;
}

export const LazyWrapper = ({ children }: LazyWrapperProps) => (
  <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
);
